<template>
  <!-- 沟通 -->
  <div class="purse-body">
    <!-- 标题 -->
    <p class="title-Individual-center">
      个人中心 <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">沟通</span>
    </p>
    <!-- 内容主体 -->
    <div class="Content-subject">
      <!-- 切换 -->
      <div class="Toggle">
        <p
          v-for="(item, index) in selectArr"
          :key="index"
          :class="select == item.id ? 'select-p' : ''"
          @click="handelSelect(item.id)"
        >
          {{ item.name }}
        </p>
      </div>
      <!-- 搜索 -->
      <div class="screen">
        <p>企业名称：</p>
        <div class="size-search">
          <el-input v-model="value" placeholder="请输入"></el-input>
        </div>
        <!-- <p class="user-Id" v-if="select == '0'">职位名称：</p>
        <div class="size-search" v-if="select == '0'">
          <el-input v-model="input" placeholder="请输入"></el-input>
        </div> -->
        <p class="user-Id">联系方式：</p>
        <div class="size-search">
          <el-select v-model="Contact" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <p class="user-Id">状态：</p>
        <div class="size-search">
          <el-select v-model="Result" placeholder="请选择">
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="screen">
        <p>时间：</p>
        <el-date-picker
          v-model="value1"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          unlink-panels
          clearable
          @clear="value1 = null"
        >
        </el-date-picker>
        <p class="ser-btn public-style" @click="handelSearch">搜 索</p>
        <p class="heavy-btn public-style" @click="handelReset">重 置</p>
      </div>
      <!-- 表格 -->
      <div class="tabulation">
        <ComTable
          :tableData="tableData"
          :select="select"
          @RefreshList="RefreshList"
          @handelAgree="handelAgree"
        ></ComTable>
      </div>
      <!-- 底部分页 -->
      <div class="paging-box">
        <div class="paging">
          <paging
            :pagingObj="pagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入接口
import {
  personGetPersonApplyRecord, //个人申请企业联系方式列表-个人
  getContactApplyRecordForElite, //精英被索要联系方式列表-个人
  agreeProvideContactInfo, //精英同意给予联系方式-个人
  rejectProvideContactInfo, //精英拒绝给予联系方式-个人
} from "../../../../../assets/api/index";
// 引入分页组件
import paging from "../../../../../components/paging.vue";
// 引入投诉表格 组件
import ComTable from "./components/ComTable.vue";

export default {
  data() {
    return {
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页数据
      options: [
        {
          value: "0",
          label: "电话",
        },
        {
          value: "1",
          label: "微信",
        },
      ], // 搜索下拉框数据
      options1: [
        {
          value: "0",
          label: "申请中",
        },
        {
          value: "1",
          label: "已同意",
        },
        {
          value: "2",
          label: "已拒绝",
        },
      ], // 搜索下拉框数据
      selectArr: [
        { name: "我联系过的企业", id: "0", frequency: "" },
        { name: "联系过我的企业", id: "1", frequency: "" },
      ], // 上方切换 投诉被投诉

      select: "0", // 筛选

      value1: null, //时间
      value: "", //搜索企业名称
      input: "", //搜索职位名称
      Contact: "", //联系方式
      Result: "", //结果

      tableData: [{}], // 表格数据
    };
  },
  watch: {

  },
  components: {
    paging,
    ComTable,
  },
  created() {
    this.handelList();
  },
  methods: {
    // 同意/拒绝刷新列表数据
    handelAgree() {
      this.handelList();
    },
    // 列表操作有变化更新列表
    RefreshList() {},
    // -------------------- 搜索 ------------------------
    handelSearch() {
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }; // 分页数据
      this.tableData = [];
      this.handelList();
    },
    // -------------------- 重置 -----------------------
    handelReset() {
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }; // 分页数据
      this.input = "";
      this.value = "";
      this.value1 = null;
      this.Contact = "";
      this.Result = "";
      this.tableData = [];
      this.handelList();
    },
    // -----------------------列表 -------------------
    async handelList() {
      // this.tableData = [];
      // 处理时间筛选
      var time;
      var timeEnd;
      var range = this.value1;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
      }

      if (this.select == "0") {
        // 接口所需参数
        var data = {
          data: {
            // 公司名
            companyName: this.value,

            // 开始时间
            applyStartTime: time,
            // 结束时间
            applyEndTime: timeEnd,
            //联系方式
            contactType: this.Contact,
            //申请结果
            status: this.Result,
          },
        };
        // 调用接口
        const res = await personGetPersonApplyRecord(
          data,
          this.pagingObj.currentPage, // 当前页
          this.pagingObj.pageSize // 一页几条
        );
        // 调用成功
        if (res.data.code == 0) {
          console.log(res, "res");
          this.tableData = res.data.data.list;
          this.pagingObj.totalDevice = res.data.data.total;
        }
      } else {
        // 接口所需参数
        var data = {
          data: {
            // 公司名
            applyCompanyName: this.value,
            // 开始时间
            applyStartTime: time,
            // 结束时间
            applyEndTime: timeEnd,
            //联系方式
            contactType: this.Contact,
            //申请结果
            status: this.Result,
          },
        };
        // 调用接口
        const res = await getContactApplyRecordForElite(
          data,
          this.pagingObj.currentPage, // 当前页
          this.pagingObj.pageSize // 一页几条
        );
        // 调用成功
        if (res.data.code == 0) {
          this.tableData = res.data.data.list;
          this.pagingObj.totalDevice = res.data.data.total;
        }
      }
    },
    // 筛选
    handelSelect(num) {
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }; // 分页数据
      this.input = "";
      this.value = "";
      this.value1 = null;
      this.Contact = "";
      this.Result = "";
      this.tableData = [];
      this.select = num;
      // this.$emit("handelSelect", num);
      this.handelList();
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.handelList();
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-date-editor {
  box-sizing: border-box !important;
  border: 1px solid #409eff ;
  height: 35px;
  width: 240px !important;
  line-height: 35px !important;
  padding: 0 8px !important;
}
/deep/.el-icon-date {
  font-size: 18px !important;
  margin-left: 0 !important;
}
/deep/.el-range__close-icon {
  line-height: 35px;
  width: 25px;
}

.purse-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .Content-subject {
    width: 100%;
    min-height: 540px;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 5px;
    margin-top: 13px;
    padding: 30px;
    display: flex;
    flex-direction: column;
    // 切换
    .Toggle {
      width: 100%;
      height: 30px;
      display: flex;
      color: #333333;
      text-align: center;
      font-weight: 400;
      p:nth-child(1) {
        margin-left: 20px;
      }
      p {
        margin-right: 40px;
        font-size: 16px;
        cursor: pointer;
      }
      .select-p {
        color: #409eff ;
        box-sizing: border-box;
        border-bottom: 2px solid #409eff ;
      }
    }
    // 搜索
    .screen {
      width: 100%;
      height: 35px;
      line-height: 35px;
      margin-top: 30px;
      display: flex;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #333333;
      font-weight: 400;
      display: flex;
      position: relative;
      .Back {
        width: 20px;
        height: 20px;
        position: absolute;
        right: 0px;
        top: 10px;
      }
      .user-Id {
        margin-left: 30px;
      }
      .public-style {
        width: 75px;
        height: 35px;
        text-align: center;
        border-radius: 5px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        font-weight: 400;
        box-sizing: border-box;
        border: 1px solid #409eff ;
        cursor: pointer;
      }
      .ser-btn {
        background: #409eff ;
        color: #ffffff;
        margin-left: 30px;
        margin-right: 10px;
      }
      .heavy-btn {
        background: #ffffff;
        color: #409eff ;
      }
      .size-search {
        width: 180px;
        height: 30px;
        font-size: 14px;
        /deep/.el-input__inner {
          height: 35px !important;
          border: 1px solid #409eff ;
        }
      }
    }
    // 表格
    .tabulation {
      min-height: 450px;
      margin-top: 30px;
    }
    // 分页
    .paging-box {
      width: 100%;
      height: 22px;
      margin-top: 30px;
      display: flex;
      justify-content: flex-end;
      .paging {
        width: 90%;
        height: 100%;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
</style>
